const validate = (values, event) => {
    /*
     * get subset of for a specific target element from an array
     * This is used from the blur event to only validate specific fields
     */
    const getSubset = event => {
        const errorSubset = {};
        const target = event.target.name;
        if (errors[target]) errorSubset[target] = errors[target];

        return errorSubset;
    };
    let errors = {};
    // required

    if (!values.firstname) {
        errors.firstname = "First Name is required";
    }

    if (!/^[a-zA-Z ']{1,50}$/.test(values.firstname)) {
        errors.firstname = "First name is invalid";
    }

    if (!values.lastname) {
        errors.lastname = "Last name is required";
    }

    if (!/^[a-zA-Z ']{1,50}$/.test(values.lastname)) {
        errors.lastname = "Last name is invalid";
    }

    if (!values.email) {
        errors.email = "Email address is required";
    }

    if (!/^(?=(.{1,64}@.{1,255}))([!#$%&'*+\-\/=?\^_`\{|}~a-zA-Z0-9}]{1,64}(\.[!#$%&'*+-\/=?^_`{|}~a-zA-Z0-9]{0,}){0,})@(([(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}])|([a-zA-Z0-9-]{1,63}(\.[a-zA-Z0-9-]{2,63}){1,})$/.test(values.email) || values.email.split("@").length > 2) {
        errors.email = "Email address is invalid";
    }

    if (values.email && values.email.length > 50) {
        errors.email = "Email address is too long (max 50 characters)";
    }

    if (!values.phonenumber) {
        errors.phonenumber = "Phone number is required";
    }

    if (!window.collectorsCorner) {
        if (!values.collectorsaccountno) {
            errors.collectorsaccountno = "Collector Account Number is required";
        }

        if (/\D/.test(values.collectorsaccountno)) {
            errors.collectorsaccountno = "Please enter a valid collector account number (numbers only)";
        }
    }

    if (!/^[+\d\s]{5,24}$/.test(values.phonenumber)) {
        errors.phonenumber = "Please enter a valid phone number (5-24 digits)";
    }

    // only validate these fields if the international Value has been set.
    if (values.internationalSet) {
        if (!values.addresslineone) {
            errors.addresslineone = "Address line one is required";
        }

        if (/[!@#$%^&*()_+\-=[\]{};':"\\|<>/?]/.test(values.addresslineone)) {
            errors.addresslineone = "Text is invalid, please remove any special characters";
        }

        if (!values.addresslinetwo) {
            errors.addresslinetwo = "Address line two is required";
        }

        if (/[!@#$%^&*()_+\-=[\]{};':"\\|<>/?]/.test(values.addresslinetwo)) {
            errors.addresslinetwo = "Text is invalid, please remove any special characters";
        }

        if (!values.postcode) {
            errors.postcode = "Post code is required";
        }

        if (/[!@#$%^&*()_+\-=[\]{};':"\\|<>/?]/.test(values.postcode)) {
            errors.postcode = "Text is invalid, please remove any special characters";
        }

        if (!values.country) {
            errors.country = "Country is required";
        }
    } else {
        if (values.manualEntry) {
            if (!values.nationaladdresslineone) {
                errors.nationaladdresslineone = "Address line one is required";
            }

            if (/[!@#$%^&*()_+\-=[\]{};':"\\|<>/?]/.test(values.nationaladdresslineone)) {
                errors.nationaladdresslineone = "Text is invalid, please remove any special characters";
            }

            if (!values.nationaladdresslinetwo) {
                errors.nationaladdresslinetwo = "Address line two is required";
            }

            if (/[!@#$%^&*()_+\-=[\]{};':"\\|<>/?]/.test(values.nationaladdresslinetwo)) {
                errors.nationaladdresslinetwo = "Text is invalid, please remove any special characters";
            }

            if (!values.nationalpostcode) {
                errors.nationalpostcode = "Eircode is required";
            }

            if (/[!@#$%^&*()_+\-=[\]{};':"\\|<>/?]/.test(values.nationalpostcode)) {
                errors.nationalpostcode = "Text is invalid, please remove any special characters";
            }

            if (!values.nationalcounty) {
                errors.nationalcounty = "County is required";
            }
        } else if (!values.reformattedAddress) {
            errors.address = "Please supply an address";
        }
    }

    // value validation for top up amount
    if (window.collectorsCorner || window.collectorsCornerTopUp) {
        const maxValue = 9999.99;
        if (!values.topUpValue) {
            errors.topUpValue = "Item value required";
        }

        if (Number(values.topUpValue) < 40) {
            errors.topUpValue = "Minimum topup value of €40";
        }

        if (Number(values.topUpValue) > maxValue) {
            errors.topUpValue = `Please enter a value lower than ${maxValue}`;
        }
    }

    if (event) {
        errors = getSubset(event);
    }
    return errors;
};

export default validate;
